var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.newsletters.length > 0)?_c('newsletter-list'):_vm._e(),(_vm.newsletters.length === 0)?_c('info-block',[_c('p',{staticClass:"info-text"},[_vm._v("Váš projekt neobsahuje žádné odběratele.")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }